export const BUSCAR_PLANO_CONTAS_CADASTRO = "BUSCAR_PLANO_CONTAS_CADASTRO"
export const BUSCAR_PLANO_CONTAS_CADASTRO_SUCESSO = "BUSCAR_PLANO_CONTAS_CADASTRO_SUCESSO"
export const BUSCAR_PLANO_CONTAS_CADASTRO_FALHA = "BUSCAR_PLANO_CONTAS_CADASTRO_FALHA"

export const SALVAR_PLANO_CONTAS_LOTE = "SALVAR_PLANO_CONTAS_LOTE"
export const SALVAR_PLANO_CONTAS_LOTE_SUCESSO = "SALVAR_PLANO_CONTAS_LOTE_SUCESSO"
export const SALVAR_PLANO_CONTAS_LOTE_IMPACTOS = "SALVAR_PLANO_CONTAS_LOTE_IMPACTOS"
export const SALVAR_PLANO_CONTAS_LOTE_ERROS = "SALVAR_PLANO_CONTAS_LOTE_ERROS"
export const SALVAR_PLANO_CONTAS_LOTE_FALHA = "SALVAR_PLANO_CONTAS_LOTE_FALHA"

export const LIMPAR_IMPACTOS_PLANO_CONTAS = "LIMPAR_IMPACTOS_PLANO_CONTAS"
